// ============================================================
//  src/admin/portfolio/portfolioData.js
// ============================================================

export const CATEGORIES = [
  "Wedding Photography",
  "Cinematic Videography",
  "Baby & Newborn Shoot",
  "Maternity Photography",
  "Pre-Wedding Shoot",
  "Bharatanatyam Photography",
  "Corporate Events",
];

export const ITEM_TYPES = ["image", "video"];

export const API_BASE_URL = "https://brandpartners.in/api/portfolio.php";

// ── Shared fetch wrapper with clear errors ───────────────────
async function apiFetch(url, options = {}) {
  let res;
  try {
    res = await fetch(url, options);
  } catch (networkErr) {
    // fetch() itself failed — CORS preflight blocked, or server is down
    throw new Error("Cannot reach the server. Check: 1) PHP files are uploaded to public_html/api/  2) uploads/ folder exists with 755 permissions.");
  }

  // Try to parse JSON even on error status — PHP may return useful message
  let body;
  try {
    body = await res.json();
  } catch {
    throw new Error(`Server returned non-JSON response (HTTP ${res.status}). Check PHP error logs in Hostinger.`);
  }

  if (!res.ok) {
    throw new Error(body?.message || `HTTP ${res.status}`);
  }

  return body;
}

// ── GET ──────────────────────────────────────────────────────
export const apiGetPortfolio = async (category = "") => {
  const url = category
    ? `${API_BASE_URL}?category=${encodeURIComponent(category)}`
    : API_BASE_URL;

  const data = await apiFetch(url);
  const arr  = Array.isArray(data) ? data : [];

  return arr.map((item) => ({
    ...item,
    image_url: item.image || null,
  }));
};

// ── POST (add new) ───────────────────────────────────────────
export const apiAddPortfolio = async (formData) => {
  return apiFetch(API_BASE_URL, {
    method: "POST",
    body: formData,   // FormData — browser sets Content-Type automatically
  });
};

// ── POST (update existing) ───────────────────────────────────
export const apiUpdatePortfolio = async (id, payload) => {
  const fd = new FormData();
  if (payload.title       !== undefined) fd.append("title",       payload.title);
  if (payload.category    !== undefined) fd.append("category",    payload.category);
  if (payload.description !== undefined) fd.append("description", payload.description);
  if (payload.type        !== undefined) fd.append("type",        payload.type);
  if (payload.featured    !== undefined) fd.append("featured",    payload.featured ? 1 : 0);
  if (payload.imageFile)                 fd.append("image",       payload.imageFile);

  return apiFetch(`${API_BASE_URL}?id=${id}`, {
    method: "POST",
    body: fd,
  });
};

// ── DELETE ───────────────────────────────────────────────────
export const apiDeletePortfolio = async (id) => {
  return apiFetch(`${API_BASE_URL}?id=${id}`, { method: "DELETE" });
};

// ── Stats helpers ────────────────────────────────────────────
export const getStats = (items = []) => ({
  total:    items.length,
  featured: items.filter((i) => Number(i.featured) === 1).length,
  images:   items.filter((i) => i.type === "image").length,
  videos:   items.filter((i) => i.type === "video").length,
});

export const getCategoryCounts = (items = []) =>
  CATEGORIES.reduce((acc, cat) => {
    acc[cat] = items.filter((i) => i.category === cat).length;
    return acc;
  }, {});

export const addItem    = () => { throw new Error("Use apiAddPortfolio instead"); };
export const updateItem = () => { throw new Error("Use apiUpdatePortfolio instead"); };
